import { Menu as ChakraMenu, Portal } from '@chakra-ui/react'
import { forwardRef } from 'react'

export const DropdownMenu = ChakraMenu.Root
export const DropdownMenuTrigger = ChakraMenu.Trigger

interface DropdownMenuContentProps {
  side?: string
  align?: string
  sideOffset?: number
  alignOffset?: number
  collisionPadding?: number
  children?: React.ReactNode
  className?: string
}

export const DropdownMenuContent = forwardRef<HTMLDivElement, DropdownMenuContentProps>((props, ref) => {
  const { side, align, sideOffset, alignOffset, collisionPadding, ...rest } = props
  return (
    <Portal>
      <ChakraMenu.Positioner>
        <ChakraMenu.Content ref={ref} {...rest} />
      </ChakraMenu.Positioner>
    </Portal>
  )
})
DropdownMenuContent.displayName = 'DropdownMenuContent'

interface DropdownMenuItemProps {
  value?: string
  onSelect?: () => void
  children?: React.ReactNode
  className?: string
}

export const DropdownMenuItem = forwardRef<HTMLDivElement, DropdownMenuItemProps>(({ value, onSelect, ...props }, ref) => {
  return (
    <ChakraMenu.Item
      ref={ref}
      value={value ?? ""}
      onClick={(e) => {
        e.preventDefault()
        onSelect?.()
      }}
      _highlighted={{ bg: 'transparent' }}
      _hover={{ bg: 'oklch(var(--secondary) / 0.6)' }}
      _focus={{ bg: 'transparent' }}
      _focusVisible={{ bg: 'transparent' }}
      {...props}
    />
  )
})
DropdownMenuItem.displayName = 'DropdownMenuItem'

export const DropdownMenuSeparator = ChakraMenu.Separator
export const DropdownMenuGroup = ChakraMenu.ItemGroup
export const DropdownMenuLabel = ChakraMenu.ItemGroupLabel
